<template>
  <div class="flex flex-col">
    <Header />

    <div
      class="flex min-h-screen min-w-screen flex-col items-center justify-center py-20"
    >
      <div
        class="animate-fade-in flex w-full flex-col gap-11.25 px-5 md:w-126.5"
      >
        <div class="flex flex-col gap-5">
          <p class="text-6xl font-medium tracking-tight text-black">
            {{ errorCode }}
          </p>

          <div class="h-px w-full bg-black" />

          <h1 class="text-2.5xl/[108%] max-w-xl text-black">
            {{ errorTitle }}
          </h1>
        </div>

        <div class="w-full">
          <Button
            :title="t('error.back')"
            href="/"
            :aria-label="t('error.back')"
            @click="handleError"
            class="**:[[id='icon']]:rotate-180"
          />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

useHead({
  bodyAttrs: {
    style: 'background-color: #E4E4E4;',
  },
})

const props = defineProps<{
  error: NuxtError
}>()

const { t } = useI18n()

const is404 = computed(() => props.error.statusCode === 404)

const errorCode = computed(() => (is404.value ? '404' : '500'))

const errorTitle = computed(() =>
  is404.value ? t('error.404.title') : t('error.500.title'),
)

const handleError = () => clearError({ redirect: '/' })
</script>
